<script lang="ts" setup>
import Modal from '@/components/base/layout/Modal.vue';
import ThemedButton from '@/components/base/ThemedButton.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header4 from '@/components/base/typography/Header4.vue';
import ProductReviews from '@/components/pdp/reviews/ProductReviews.vue';
import { ApprovedReviews } from '@/lib/reviews';
import { NutsProductVariant } from '@/utils/product';

defineProps<{
  isModalOpen: boolean;
  productImage?: string;
  productKey: string;
  productName: string;
  reviews: ApprovedReviews;
  selectedVariant: NutsProductVariant;
}>();

const emit = defineEmits<{
  'handle-close': [];
  'review-submitted': [];
  'write-a-review': [];
}>();
</script>

<template>
  <Modal
    aria-label="reviews list"
    class="apply-items-end"
    :hasControls="false"
    :isOpen="isModalOpen"
    width="lg:max-w-lg"
    @handle-close="emit('handle-close')"
  >
    <template #header>
      <Header4>Customer Reviews</Header4>
      <div class="flex pb-3 mt-4 border-b border-solid border-neutral-200">
        <img :alt="`${productName} photo`" class="h-10 w-14" :src="productImage" />
        <div class="ml-2">
          <BaseBodyText class="font-bold">{{ productName }}</BaseBodyText>
        </div>
      </div>
    </template>
    <template #body>
      <ProductReviews
        class="mt-3"
        :productKey="productKey"
        :reviews="reviews"
        @review-submitted="emit('review-submitted')"
        @write-a-review="emit('write-a-review')"
      >
        <template #footer-mobile-secondary-btn>
          <ThemedButton class="whitespace-nowrap" theme="green" @click="emit('handle-close')">
            Exit Reviews Tab
          </ThemedButton>
        </template>
      </ProductReviews>
    </template>
  </Modal>
</template>

<style scoped>
.apply-items-end {
  @apply items-end;
}
</style>
